import { useResizableSidebar } from "../../hooks/use-resize-wrapper";
import { StorageScope } from "../../../../services/api/instances/storageApi/types/service_types";
import styles from "./styles.module.css";
import classNames from "classnames";

interface Props {
  children: React.ReactNode;
  service: StorageScope;
  isSidebarOpen: boolean;
  defaultWidth?: number;
  minWidth?: number;
  maxWidth?: number;
}

export const SidebarResizableWrapper = ({
  children,
  service,
  isSidebarOpen,
  defaultWidth = 260,
  minWidth = 250,
  maxWidth = 400,
}: Props) => {
  const { containerRef, sidebarRef, startResizing } = useResizableSidebar({
    service,
    defaultWidth,
    minWidth,
    maxWidth,
  });

  const cls = classNames(
    styles.container,
    !isSidebarOpen && styles["sidebar-container-close"],
  );

  const sidebarCls = classNames(
    styles.sidebar,
    !isSidebarOpen && styles["sidebar-close"],
  );

  const resizerCls = classNames(
    styles.resizer,
    !isSidebarOpen && styles["resizer-hidden"],
  );

  return (
    <div ref={containerRef} className={cls}>
      <aside ref={sidebarRef} className={sidebarCls}>
        {children}
      </aside>
      <div
        className={resizerCls}
        onMouseDown={startResizing}
        role="separator"
        aria-orientation="vertical"
      />
    </div>
  );
};
